module.exports = __webpack_public_path__ + "img/rw.9ae01851.svg";